// extracted by mini-css-extract-plugin
module.exports = {"base":"CopyButton_base__1r3Nt","copiedIcon":"CopyButton_copiedIcon__28WrL","popover":"CopyButton_popover__2IHQ4","floatRight":"CopyButton_floatRight__1Jkjl"};